<template>
  <div>
    <!-- 基础信息 -->
    <div class="basicInformation">
      <div class="list">
        <!-- 商品名称（日语） -->
        <div class="item productNameJapanese">
          <div class="name">
            {{ $t('message.productNameJapanese') }}
          </div>
          <div class="content">
            {{ detail.goods_title }}
          </div>
        </div>
        <!-- 附加服务） -->
        <div class="item additionalServices">
          <div class="name">
            {{ $t('message.additionalServices') }}
            <!-- 详细 -->
            <el-button type="text" class="fr" @click="$refs.optionlist.setData(detail.option)">{{ $t('message.detail')
            }}</el-button>
          </div>
          <div class="content">
            <el-popover placement="bottom" width="160" trigger="hover">
              <p v-for="(item, index) in detail.option" :key="index">
                {{ index + 1 }}) {{ item.name }}
              </p>
              <div slot="reference">
                <p v-for="(item, index) in detail.option" :key="index">
                  {{ index + 1 }}) {{ item.name }}
                </p>
              </div>
            </el-popover>
          </div>
        </div>
        <!-- 标签信息 -->
        <div class="item tagInformation">
          <div class="name">
            {{ $t('message.tagInformation') }}
          </div>
          <div class="content">
            <div class="tagList">

              <div class="tagItem" v-for="(tag, tagIndex) in detail.client_product_tag" :key="tagIndex">
                <el-popover placement="top" width="405" trigger="hover">
                  <el-table :data="[tag]" border>
                    <el-table-column property="text_line_one" label="文本1" align="center"></el-table-column>
                    <el-table-column width="100" property="text_line_two" label="文本2" align="center"></el-table-column>
                    <el-table-column width="100" property="text_line_three" label="文本3"
                      align="center"></el-table-column>
                    <el-table-column width="100" property="text_line_four" label="文本4" align="center"></el-table-column>
                  </el-table>
                  <div slot="reference">
                    <div class="row">
                      <div class="label">仓库类别 </div>
                      <div class="value">{{ tag.type }}</div>
                    </div>
                    <div class="row">
                      <div class="label">标签条码 </div>
                      <div class="value">{{ tag.no }}</div>
                    </div>
                    <div class="row">
                      <div class="label">商品编码 </div>
                      <div class="value">{{ tag.goods_no }}</div>
                    </div>
                  </div>
                </el-popover>


              </div>
            </div>
          </div>
        </div>
        <!-- 绑定辅料 -->
        <div class="item bindingAuxiliaryMaterials additionalServices">
          <div class="name">
            {{ $t('message.bindingAuxiliaryMaterials') }}
          </div>
        </div>
        <!-- 商品管理备注 -->
        <div class="item productManagementRemarks">
          <div class="name">
            {{ $t('message.productManagementRemarks') }}
          </div>
          <div class="content">
            <el-input type="textarea" v-model="detail.remark" @blur="updateRemark"></el-input>
          </div>
        </div>
      </div>
      <!-- 第二行   -->
      <div class="list list2">
        <!-- 实物图 -->
        <div class="item pic">
          <div class="name">
            {{ $t('message.physicalImage') }}
            <!-- 查看更多 -->
            <el-button type="text" class="fr" @click="$refs.physicalImage.setData(detail)">{{ $t('message.seeMore')
            }}</el-button>
          </div>
          <div class="content">
            <div class="picList">
              <el-image style="width: 126px;height: 126px;;border-radius: 5px; " :src="pic.url"
                :preview-src-list="[pic.url]" v-for="(pic, picIndex) in detail.client_product_image" :key="picIndex"
                :style="{ marginRight: picIndex == 0 ? '12px' : 0 }">
              </el-image>
            </div>
          </div>
        </div>
        <!-- 捆包图 -->
        <div class="item pic">
          <div class="name">
            {{ $t('message.packingDiagram') }}
          </div>
          <div class="content">
            <div class="picList">
              <el-image style="width: 126px;height: 126px;;border-radius: 5px; " :src="pic.url"
                :preview-src-list="[pic.url]" v-for="(pic, picIndex) in detail.client_product_image_pack"
                :key="picIndex" :style="{ marginRight: picIndex == 0 ? '12px' : 0 }">
              </el-image>
            </div>
          </div>
        </div>
        <!-- 商品文件 -->
        <div class="item productFile">
          <div class="name">
            {{ $t('message.productFile') }}
          </div>
          <div class="content">
            <div class="file">
              <!--商品定制文件  -->
              <div class="item" v-for="(file, fileIndex) in detail.client_product_file_cate" :key="fileIndex">
                <div class="item-name">{{ file.cate_name }}</div>
                <div class="file-item" v-for="(product_file, product_file_index) in file.client_product_file"
                  :key="product_file_index">
                  <a :href="product_file.url" target="_blank" rel="noopener noreferrer" class="a-link">{{
                    product_file.name }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 通关信息 -->
        <div class="item customsClearanceInformation">
          <div class="name">
            {{ $t('message.customsClearanceInformation') }}
          </div>
          <div class="content" v-if="detail.client_product_clearance">
            <div class="row">
              <div class="label">品名 </div>
              <div class="value" v-if="detail.client_product_clearance.pingming_en">{{
                detail.client_product_clearance.pingming_en }}</div>
              <div class="value" v-else-if="detail.client_product_clearance.pingming_ja">{{
                detail.client_product_clearance.pingming_ja }}</div>
              <div class="value" v-else-if="detail.client_product_clearance.pingming_zh">{{
                detail.client_product_clearance.pingming_zh }}</div>
            </div>
            <div class="row">
              <div class="label">材质 </div>
              <div class="value" v-if="detail.client_product_clearance.material_en">{{
                detail.client_product_clearance.material_en }}</div>
              <div class="value" v-else-if="detail.client_product_clearance.material_ja">{{
                detail.client_product_clearance.material_ja }}</div>
              <div class="value" v-else-if="detail.client_product_clearance.material_zh">{{
                detail.client_product_clearance.material_zh }}</div>
            </div>
            <div class="row">
              <div class="label">HSCODE </div>
              <div class="value">{{ detail.client_product_clearance.hscode }}</div>
            </div>
            <div class="row">
              <div class="label">税率 </div>
              <div class="value">{{ detail.client_product_clearance.tax_rate }} %</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- option -->
    <optionlist ref="optionlist" />
    <!-- 实物图 -->
    <physicalImage ref="physicalImage" />
  </div>
</template>
<script>
import optionlist from './option'
import physicalImage from './physicalImage'
export default {
  components: {
    optionlist,
    physicalImage
  },
  props: {
    detail: { type: Object }
  },

  data() {
    return {

    };
  },
  methods: {
    //修改备注
    updateRemark() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code_set: [this.detail.sys_code],
        remark: this.detail.remark,
      }
      this.$api.productManagementApi.updateRemark(datas)
    },
  }
}
</script>
<style lang='scss' scoped>
.basicInformation {
  margin-top: 12px;

  .list {
    display: flex;

    .productNameJapanese {
      width: 280px;
    }

    .additionalServices {
      width: 160px;
    }

    .productManagementRemarks {
      width: 270px;
    }

    .tagInformation {
      flex: 1;
    }

    .item {
      padding: 20px;
      background: #F7F8FA;
      border-radius: 10px;
      margin-right: 12px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      .name {
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        margin-bottom: 20px;

        .el-button {
          line-height: 20px;
          padding: 0;
        }
      }

      .content {
        height: 82px;
        line-height: 21px;
        overflow: hidden;
        /* 隐藏超出部分 */
        display: -webkit-box;
        /* 使用Webkit的盒模型 */
        -webkit-line-clamp: 4;
        /* 限制最多显示两行 */
        -webkit-box-orient: vertical;

        /* 设置盒模型的方向为垂直 */
        /deep/.el-textarea__inner {
          height: 82px !important;
          resize: none;
          padding: 5px;
        }

        .tagList {
          display: flex;
          width: 100%;

          .tagItem {
            padding: 8px;
            border-radius: 4px;
            border: 1px solid #DFDFDF;
            margin-right: 12px;

            &:nth-last-child(1) {
              margin-right: 0;
            }

            .row {
              display: flex;

              .label {
                width: 65px;
                margin-right: 17px;
              }

              &:nth-last-child(1) {
                margin: 0;
              }
            }
          }
        }
      }
    }
  }

  .list2 {
    margin-top: 12px;

    .pic {
      width: 264px;
    }

    .customsClearanceInformation {
      width: 236px;
    }

    .productFile {
      flex: 1;
    }

    .content {
      min-height: 126px !important;

      .row {
        display: flex;
        line-height: 21px;

        .label {
          width: 70px;
        }
      }

      .file {
        display: flex;

        .item {
          width: 220px;
          padding: 10px;
          margin-right: 12px;
          background-color: #fff;
          border-radius: 4px;
          height: 106px;
          overflow: hidden;

          &:nth-last-child(1) {
            margin: 0;
          }

          .item-name {
            margin-bottom: 8px;
          }
        }
      }
    }
  }
}
</style>